import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
import Register from "./views/Register.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import ChangePassword from "./views/ChangePassword.vue";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import Orders from "./views/Orders.vue";
import DailyMenu from "./views/DailyMenu.vue";
import MenuCard from "./views/MenuCard.vue";
import Options from "./views/Options.vue";
import DeliveryZones from "./views/DeliveryZones.vue";
import Customers from "./views/Customers.vue";
import Billing from "./views/Billing.vue";
import Settings from "./views/Settings.vue";
import Widget from "./views/Widget.vue";
import QrCodes from "./views/QrCodes.vue";
import Create from "./views/Create.vue";

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next();
    return;
  }
  next("/login");
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/forgotpassword",
      name: "forgotpassword",
      component: ForgotPassword
    },
    {
      path: "/changepassword",
      name: "changepassword",
      component: ChangePassword
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/menu",
      name: "menu",
      component: DailyMenu,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/dishes",
      name: "dishes",
      component: MenuCard,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/options",
      name: "options",
      component: Options,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/zones",
      name: "zones",
      component: DeliveryZones,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/customers",
      name: "customers",
      component: Customers,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/widget",
      name: "widget",
      component: Widget,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/qrcodes",
      name: "qrcodes",
      component: QrCodes,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/create",
      name: "create",
      component: Create,
      beforeEnter: ifAuthenticated
    },
    {
      path: "*",
      redirect: { name: 'dashboard' },
      beforeEnter: ifAuthenticated
    }
  ]
});

router.afterEach((to) => {
  try {
    gtag('config', 'G-QDDWK7GTGM', {
      page_title: to.name,
      page_path: to.path,
      send_page_view: true,
    });
  } catch (e) {
    console.log("Tracking disabled")
  }
});

export default router
